<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <DialogNearestBanks ref="dialogNearestBanks"></DialogNearestBanks>
    <DialogJSONError ref="dlgError"></DialogJSONError>
    <DialogMissingCmp ref="myDialogMissingCmp"></DialogMissingCmp>
    <v-toolbar app color="#fdfdfd" flat height="60px" id="myToolbar" style="z-index: 2">
        <v-card color="transparent" flat v-if="!isLogin" class="pt-2 hidden-xs-only" to="/Dashboard"
                style="position: fixed; top: 10px; width: 100%;"
        >
          <img :src="'./static/' + logoExtImage"
               height="30px"
               width="auto"
          >
        </v-card>
      <v-card color="transparent" flat v-if="!isLogin" class="pt-2 hidden-sm-and-up" to="/Dashboard"
              style="position: fixed; top: 15px; width: 75%;"
      >
        <img :src="'./static/eValueRate_Logo2.png'"
             height="20px"
             width="auto"
        >
      </v-card>

      <v-menu top offset-y v-if="!isLogin" style="z-index:10000000000000000000; position: absolute;"
              v-model="menuVisible">

        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" small>
            <v-icon color="#004884">menu</v-icon>
          </v-btn>
        </template>
        <v-card width="250" color="white" flat>
          <v-card color="blue" class="body-2 pa-1 font-weight-bold white--text">
            {{'ACCOUNT_TITLE_LOGIN' | translate}}: {{foreName}} {{lastName}}
          </v-card>
          <v-divider></v-divider>
          <v-layout justify-start style="background-color: white">
            <!--
            :active.sync="active" return-object v-model="tree" @change="openMenuItem" :items="items" :active="active" :open="open" open-on-click activatable
            -->

            <v-treeview :active.sync="activeTreeModel" :open="open" open-on-click v-model="tree" :items="items"
                        @change="openMenuItem" return-object>
              <template v-slot:label="{ item, open }">
                <span style="float:left;" class="body-1 TextNav"
                      @click="openMenuItem(item)">{{item.name | translate}}</span>
              </template>
            </v-treeview>
          </v-layout>

          <v-card-actions style="background-color: white">
            <v-btn to="/Logout" color="blue" dark small block class="font-weight-bold text-none">
              {{'BUTT_LOGOUT' | translate}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <BtnBack  v-if="!isDashboard && !hideCauseLogin" class="hidden-xs-only"></BtnBack>
      <v-card color="transparent" flat v-if="showRegister" class="marginlogo toolbarIE pt-2" to="/Dashboard">
        <img :src="'./static/eValueRate_Logo2.png'"
             height="25px"
             width="auto"
        >
      </v-card>

      <v-card flat>
        <!--<v-card-text class="bluetext pl-2 caption pb-2" v-if="!isLogin">
          {{idModule}}
        </v-card-text>-->
      </v-card>

      <v-spacer></v-spacer>

      <div class="menusearch hidden-sm-and-down" v-if="!isLogin">
        <v-menu
          v-model="myMenu"
          :close-on-content-click="false"
          content-class="menusearch"
          :nudge-width="100"
          offset-x
          left
          ref="smenu"
        >
          <template v-slot:activator="{ on }">
            <!--
            /* @mouseover="onSearchIconOver()" */
             @mouseover="myMenu = true"
            -->
            <v-btn
              color="primary"
              dark
              flat
              icon
              round
              v-on="on"
              @click="onSearchIconOver()"
            >
              <v-icon large>
                search
              </v-icon>
            </v-btn>
          </template>
          <v-card width="400px" flat color="transparent">
            <v-autocomplete
              v-model="overallSearchText"
              :items="itemsresults"
              :search-input.sync="search"
              color="#004884"
              dont-fill-mask-blanks
              :filter="doFilterAC"
              return-object
              id="myOverallSearch"
              @mouseleave="checkout()"
              background-color="grey lighten-4"
              class="mx-3"
              ref="acField"
              flat
              :key="acKey"
              single-line
              item-text="title"
              clearable
              @keyup="onKeyUp"
              hide-details
              hide-selected
              :label="labelsuchen"
              solo
              @change="onClickSearchItem"
            >
              <template v-slot:no-data>
                &nbsp;
                <span style="text-align: left"></span>
              </template>
              <template v-slot:item="{ item }">
                <span style="text-align: left">{{ item.name}}</span>
              </template>
            </v-autocomplete>
          </v-card>
        </v-menu>
      </div>
      <div class="px-1 hidden-sm-and-down">
        <v-menu open-on-click top offset-y v-if="!isLogin" z-index="9000000">
          <template v-slot:activator="{ on }">
            <!--<v-btn small fab flat outline @click="showMenu" v-on="on" color="#004884">
              <v-icon medium>person</v-icon>
            </v-btn>-->
            <v-avatar size=40 color="transparent" v-on="on" class="pointer" @click="showMenu">
              <v-icon color="#004884">person</v-icon>
            </v-avatar>
          </template>
          <v-card width="200px">
            <v-card>
              <v-card color="blue" class="body-2 pa-1 font-weight-bold white--text">
                {{'ACCOUNT_TITLE_LOGIN' | translate}}: {{foreName}} {{lastName}}
              </v-card>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in itemsAvatar"
                  :key="index"
                  @click="openMenuItem(item)"
                  class="body-2 bluetext"
                >
                  <v-list-tile-title class="body-2 bluetext">
                    <v-icon color="#004884">{{ item.icon}}</v-icon>
                    {{ item.title | translate}}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-card>
        </v-menu>
      </div>
      <div class="mr-5">
        <v-btn depressed :color="getLangColor('de')" :class="getLangClass('de')" flat fab small class="mx-0"
               @click="setLocale('de')">DE
        </v-btn>
        <v-btn depressed :color="getLangColor('en')" :class="getLangClass('en')" flat fab small class="mx-0"
               @click="setLocale('en')">EN
        </v-btn>
      </div>
      <btnSupport></btnSupport>
    </v-toolbar>
   <!-- <v-container>
      <v-flex xs12>
        <v-card class="bluetext caption text-xs-center justify-center hidden-xs-only" v-if="!isLogin" style="z-index: 300;background-color: red">
          {{idModule}}
        </v-card>
      </v-flex>
    </v-container> -->
  </div>
</template>

<script>
import Vue from 'vue'
import BtnBack from './widgets/BtnBack'
import btnSupport from './widgets/BtnSupport'
import DialogMissingCmp from "@/components/module/dialogs/DialogMissingCmp";
import DialogNearestBanks from '@/components/module/dialogs/DialogNearestBanks'
import DialogJSONError from '@/components/dialogs/DialogJSONError'
import $ from 'jquery'

export default {
  name: 'Toolbar.vue',
  components: {BtnBack, btnSupport, DialogNearestBanks,DialogJSONError, DialogMissingCmp},
  data () {
    return {
      language: 'de',
      headerFields: [{'id': 'companyName', 'type': 'nm', 'orderNr': '0', 'name': 'Name des Unternehmens'}, {
        'id': 'rk',
        'type': 'nm',
        'orderNr': '1',
        'name': 'Rechtskreis'
      }, {'id': 'aa', 'type': 'nm', 'orderNr': '2', 'name': 'Abschlussart'}, {
        'id': 'year',
        'type': 'nm',
        'orderNr': '4',
        'name': 'Jahr'
      }, {
        'id': 'source',
        'type': 'nm',
        'orderNr': '5',
        'name': 'Quelle'
      }],
      isLogin: true,
      logoExtImage: '',
      isDashboard: true,
      idModule: 'Unternehmen',
      loading: false,
      labelsuchen: Vue.i18n.translate('LABLE_SEARCH'),
      acKey: 1,
      search: null,
      select: null,
      itemsresults: [],
      results: [],
      tree: [],
      showSearchField: false,
      active: [],
      isCRS: Vue.prototype.$config.IS_CRS,
      open: [1],
      showBackBtn: false,
      menuVisible: false,
      onb: false,
      on: false,
      on2: false,
      foreName: '',
      lastName: '',
      hideCauseLogin: false,
      activeTreeModel: [],
      crumps: [],
      overallSearchText: '',
      itemsAvatar: [],
      items: [],
      myMenu: false,
      showRegister: false
    }
  },
  watch: {
    on (val) {
      this.on = val
      if (!this.on) {
        Vue.prototype.$eventHub.$emit('OnShowIdle', false)
      }
    },
    activeTree (val) {
      this.active = val
      Vue.prototype.$api.debug('activeTree', val)
      if (val.length > 0) {
        this.openMenuItem(val[0])
      }
    },
    search (val) {
      val && val !== this.overallSearchText && this.querySelections(val)
    }
  },
  methods: {
    doFilterAC: function(item, queryText, itemText) {
      // console.log('doFilterAC', item, queryText, itemText)
      // itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      return true
    },
    setLocale: function (language) {
      var languageId = 1
      Vue.prototype.$config.language = language
      if (language === 'de') {
        languageId = 1
      } else if (language === 'en') {
        languageId = 2
      }
      Vue.prototype.$config.languageId = languageId
      this.language = language
      Vue.i18n.set(language)

      Vue.prototype.$api.getI18NFromServer(function () {
        Vue.prototype.$api.debug('setlocale', Vue.prototype.$config.languageId)
        Vue.prototype.$eventHub.$emit('setLocale', Vue.prototype.$config.languageId)
        Vue.prototype.$eventHub.$emit('setLocale2', Vue.prototype.$config.languageId)
      })
    },
    getLangColor: function (lan) {
      if (lan === this.language) {
        return ''
      } else {
        return ''
      }
    },
    showError: function (data) {
      Vue.prototype.$api.debug('showError', data)
      Vue.prototype.$api.hideIdle()

      if (data && data.isDetail) {
        this.$refs.dlgError.open({
          newName: data.title,
          title: data.title,
          type: '',
          description: data.message
        })
      } else {
        let s = ""
        if (data.status) {
          s = data.status
        }
        let errorMsg = ""
        if (errorMsg) {
          errorMsg = data.errorMsg
        }
        this.$refs.dlgError.open({
          newName: Vue.i18n.translate('JSON_FAILED_TITLE'),
          title: Vue.i18n.translate('JSON_FAILED_TITLE') + ' ' + s,
          type: '',
          description: Vue.i18n.translate('JSON_FAILED_DESCRIPTION') + errorMsg
        })
      }
    },
    getLangClass: function (lan) {
      if (lan === this.language) {
        return 'countrySelected'
      } else {
        return 'countryDefault'
      }
    },

    OnShowRegister: function (d) {
      this.showRegister = d
    },
    OnShowLogin: function (show) {
      this.hideCauseLogin = show
    },
    onEnterOverallSearch: function (item) {
      // Vue.prototype.$eventHub.$emit('OnOverallSearch', this.overallSearchText)
      this.onClickSearchItem(item)
    },
    onGetNearestBank: function (data) {
      Vue.prototype.$api.debug('onGetNearestBank', data, this.idModule)
      this.idModule = Vue.prototype.$api.getModuleId()
      if (data.table.rows.length < 1) {
        var balance = {
          aaNr: '0',
          crefoNr: this.currentCrefoNr,
          rkNr: '0',
          source: '0',
          year: '0'
        }
        Vue.prototype.$api.debug('open balance', balance)

        // this.$router.push(Vue.prototype.$api.getStructureUrl(this.idModule, balance))
        var url = '/Forward?url=' + Vue.prototype.$api.getStructureUrl(this.idModule, balance)
        Vue.prototype.$api.debug('url', url)
        this.$router.push({ path:url, meta: {
          forward: true
        }})
        return
      }
      if (data.table.rows.length === 1) {
        var balance = data.table.rows[0].balance
        var url = '/Forward?url=' + Vue.prototype.$api.getStructureUrl(this.idModule, balance)
        Vue.prototype.$api.debug('url', url)
        this.$router.push({ path:url, meta: {
          forward: true
        }})
      } else {
        this.$refs.dialogNearestBanks.show(data)
      }
    },
    OnOpenOSItem: function (item) {
      Vue.prototype.$api.debug('openOSItem di tb', item)
      this.currentCrefoNr = item.meta.crefoNr
      var moduleName = item.tableConfig.tableName
      var cmp = this
      var credits = Vue.prototype.$api.getCredentials()
      var cModule = credits.moduleList[moduleName]

      if (Vue.prototype.$api.isAllowedToOpenModule(moduleName)) {
        // Module Id im dialogNearestBanks anzeigen
        this.$refs.dialogNearestBanks.setModuleId(moduleName)
        Vue.prototype.$api.setModule(cModule, function (res) {
          var result = Vue.prototype.$api.createSearchDataFromFieldsWithCrefoNr(cmp, cmp.headerFields, cmp.currentCrefoNr, moduleName)
          Vue.prototype.$api.searchNearestBanks(result.searchData, cmp.onGetNearestBank, Vue.prototype.$api.onFailure)
        })
      } else {
        this.$refs.myDialogMissingCmp.show({})
      }
    },
    onSearchIconOver: function (event) {
      // this.$refs.acField.focus()
      // var input = this.$refs.acField.$el.querySelector('input')
      // console.log(jQuery('#myOverallSearch'))
      this.search = ''
      window.jQuery('#myOverallSearch').focus();
      window.setTimeout(function () {
        window.jQuery('#myOverallSearch').focus();
      }, 100)
      window.setTimeout(function () {
        window.jQuery('#myOverallSearch').focus();
      }, 500)
    },
    onKeyUp: function (event) {
      Vue.prototype.$api.debug('event (' + this.overallSearchText + this.search + ')')
      if (event.key.toLowerCase() === 'enter') {
        var s = this.search
        Vue.prototype.$api.resetAll()
        Vue.prototype.$eventHub.$emit('OnOverallSearch', s)
        this.search = null
      }
    },
    onClickSearchItem: function (item) {
      if (item == null) return
      this.search = null
      this.overallSearchText = ''
      Vue.prototype.$api.debug('onClickSearchItem', item, item.module)
      this.currentCrefoNr = item.crefoNr

      var moduleName = item.module
      var cmp = this
      var credits = Vue.prototype.$api.getCredentials()
      Vue.prototype.$api.setModuleId(item.module)
      var cModule = credits.moduleList[moduleName]
      if (Vue.prototype.$api.isAllowedToOpenModule(moduleName)) {
        Vue.prototype.$api.resetAll()
        Vue.prototype.$api.setModule(cModule, function (res) {
          Vue.prototype.$api.debug('set module done', res)
          var result = Vue.prototype.$api.createSearchDataFromFieldsWithCrefoNr(cmp, cmp.headerFields, cmp.currentCrefoNr, moduleName)
          Vue.prototype.$api.searchNearestBanks(result.searchData, cmp.onGetNearestBank, Vue.prototype.$api.onFailure)
        })
      } else {
        this.$refs.myDialogMissingCmp.show({})
      }
      this.acKey++
    },
    onClick: function () {
      window.history.back()
    },
    showMenu () {
      // Vue.prototype.$eventHub.$emit('OnShowIdle', true)
    },
    OnSetLocale () {
      this.labelsuchen = Vue.i18n.translate('LABLE_SEARCH')
      this.OnGetModuleTitle('')
    },
    OnGetModuleTitle (title) {
      this.showBackBtn = title !== ''
      var t = ''
      if (Vue.prototype.$api.getModuleId() != null) {
        t = Vue.i18n.translate(Vue.prototype.$api.getModuleId().toUpperCase() + '_TITLE')
        this.logoExtImage = 'eValueRate_Logo_Module_' + Vue.prototype.$api.getModuleId().toLowerCase()
      } else {
        this.logoExtImage = 'eValueRate_Logo_Module'
      }
      if (Vue.prototype.$api.getLanguage() === 2) {
        this.logoExtImage = this.logoExtImage + '_en'
      }
      this.logoExtImage = this.logoExtImage + '.png'

      this.idModule = t + ' ' + title
    },
    onGetBreadcrumb (data) {
      // console.log('onGetBreadcrumb', data)
      this.isDashboard = !data || data.length <= 1
      this.crumps = data
    },
    openMenuItem (item) {
      Vue.prototype.$api.debug('item', item)
      if (item.link) {
        this.$router.push(item.link)
        // this.$router.push('/di/' + item.link + '/' + this.idModule)
        //this.$router.push(item.link + '/' + this.idModule)
        // this.$router.push('/di/Module/' + 'companies')
        return
      }
      if (item.id === '0') {
        this.$router.push('/Dashboard')
      } else if (item.id === '22') {
        this.$router.push('/di/Newsbox')
      } else if (item.id === '998') {
        this.$router.push('/ResetPassword')
      } else if (item.id === '999') {

        Vue.prototype.$eventHub.$emit('OnGetModuleTitle', '')
        Vue.prototype.$eventHub.$emit('OnLogin', true)
        this.$router.push('/Logout')
      }
    },
    OnLogin (ok) {
      this.isLogin = !ok
      if (ok) {
        this.foreName = Vue.prototype.$api.getCredentials().data.user.firstName
        this.lastName = Vue.prototype.$api.getCredentials().data.user.lastName
      } else {
        return
      }
      this.updateMenu()
    },
    updateMenu () {
      this.menuVisible = false
      this.itemsAvatar = []
      this.items = []
      this.items.push({
        id: '0',
        name: 'MENU_DASHBOARD'
      })
      this.moduleList = Vue.prototype.$api.getModuleList()
      for (var i in this.moduleList) {
        var module = this.moduleList[i]
        if (module.privateDB || module.publicDB) {
          this.items.push({
            id: module.id,
            name: module.id.toUpperCase() + '_TITLE',
            link: '/di/Module/' + module.id
            //this.$router.push('/di/' + item.link + '/' + this.idModule)
          })
        }
      }

      //this.items = this.items.concat([{
       // id: '22',
       // name: 'MENU_NEWSBOX'
      //}
      //])

      if (Vue.prototype.$api.isAdmin()) {
        this.items = this.items.concat([
          {
            id: '42',
            link: '/di/Administration',
            name: 'MENU_ADMINISTRATION'
          }
        ])
      }

      this.items = this.items.concat([
        {
          id: '998',
          name: 'MENU_CHANGE_PASSWORD'
        }
      ])

      this.itemsAvatar.push(
        {
          id: '998',
          icon: 'build',
          title: 'MENU_CHANGE_PASSWORD'
        }
      )
      this.itemsAvatar.push(
        {
          id: '999',
          icon: 'power_settings_new',
          title: 'BUTT_LOGOUT'
        }
      )
    },
    onHit () {
      Vue.prototype.$api.debug('smenu', this.$refs)
      this.myMenu = true
    },
    onLogout () {
      this.loging = true
      Vue.prototype.$eventHub.$emit('OnGetBreadcrumb', [])
    },
    onGetHyperData (data) {
      Vue.prototype.$api.debug('hyper', data)
      this.loading = false
      this.itemsresults = []
      for (var index in data) {
        var d = data[index]
        d['title'] = d['crefoNr'] + ' ' + d['name']
        this.itemsresults.push(d)
      }
      Vue.prototype.$api.debug('this.itemsresults', this.itemsresults)
    },
    checkout () {
      Vue.prototype.$api.debug('checkout', this.search)
      if (this.search && this.search.length > 1) return
      this.myMenu = false
    },
    querySelections (v) {
      this.loading = true
      // Simulated ajax query

      Vue.prototype.$api.requestHyperSearchAC(v, this.onGetHyperData)
      /*
      setTimeout(() => {
        if (v.length  != 0) {
          this.itemsresults = this.results.filter(e => {
            return (e.name || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
        } else {
          this.itemsresults = []
        }

      }, 500)

       */
    }
  },
  created () {
    Vue.prototype.$eventHub.$on('OnLogin', this.OnLogin)
    Vue.prototype.$eventHub.$on('OnShowError', this.showError)
    Vue.prototype.$eventHub.$on('openOSItem', this.OnOpenOSItem)
    Vue.prototype.$eventHub.$on('OnLogout', this.onLogout)
    Vue.prototype.$eventHub.$on('OnShowLogin', this.OnShowLogin)
    Vue.prototype.$eventHub.$on('OnShowRegister', this.OnShowRegister)
    Vue.prototype.$eventHub.$on('OnGetBreadcrumb', this.onGetBreadcrumb)
    Vue.prototype.$eventHub.$on('OnGetModuleTitle', this.OnGetModuleTitle)
    Vue.prototype.$eventHub.$on('setLocale', this.OnSetLocale)
  },
  destroyed () {
    Vue.prototype.$eventHub.$off('OnLogin', this.OnLogin)
    Vue.prototype.$eventHub.$off('OnShowError', this.showError)
    Vue.prototype.$eventHub.$off('openOSItem', this.OnOpenOSItem)
    Vue.prototype.$eventHub.$off('OnShowLogin', this.OnShowLogin)
    Vue.prototype.$eventHub.$off('OnShowRegister', this.OnShowRegister)
    Vue.prototype.$eventHub.$off('OnLogout', this.onLogout)
    Vue.prototype.$eventHub.$off('OnGetBreadcrumb', this.onGetBreadcrumb)
    Vue.prototype.$eventHub.$off('OnGetModuleTitle', this.OnGetModuleTitle)
    Vue.prototype.$eventHub.$off('setLocale', this.OnSetLocale)
  },

  mounted () {
    var cmp = this
    Vue.prototype.$api.checkCredentials(this)
    this.menuVisible = false
    this.on = false
    this.language = Vue.prototype.$config.language
    this.showSearchField = false

    var onFocus = function () {
      Vue.prototype.$api.debug('Inhalt bei focus', cmp.search)
      $(this).parent().find("label").addClass('active')
      $('#sdiv').addClass('activeAC')
      $('#sdiv').find("div[name=hide]").removeClass('hideSearch')
    }
    var onLeave = function () {
      Vue.prototype.$api.debug('Inhalt lost', cmp.search)
      if (!cmp.search || cmp.search.length === 0) {
        $(this).parent().find("label").removeClass('active')
        $('#sdiv').removeClass('activeAC')
        $('#sdiv').find("div[name=hide]").addClass('hideSearch')
      } else {
        cmp.overallSearchText = this.search
      }
    }
    window.setTimeout(function () {
      $('#sdiv').on('focus', onFocus)
      $('#sdiv').hover(onFocus)
      $('#sdiv').on('blur', onLeave)
      $('#sdiv').mouseleave('blur', onLeave)
    }, 500)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue